import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
  isLoading: false,
  error: null,
  invoices: [],
  invoice: null,
  warehouses: [],
};

const slice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getInvoicesSuccess(state, action) {
      state.isLoading = false;
      state.invoices = action.payload;
    },
    getInvoiceSuccess(state, action) {
      state.isLoading = false;
      state.invoice = action.payload;
    },
    getWareHouseSuccess(state, action) {
      state.isLoading = false;
      state.warehouses = action.payload;
    },
    resetStockStore() {
      return initialState;
    },

    updateInvoiceStatus(state, action) {
      const { id, newStatus } = action.payload;
      const orderIndex = state.invoices.findIndex(
        (order) => order.id === id
      );
      if (orderIndex !== -1) {
        state.invoices[orderIndex].invoiceState = newStatus;
      }
    },
  },
});

export default slice.reducer;

export function getInvoices(
  warehouseId,
  startDate = null,
  endDate = null
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = {
        warehouseId,
        isDeleted: false,
        excludeStatus: "drafted",
        // isActivePurchaseOrder: false,
        limit: 100000000,
      };

      if (startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      const response = await axios.get(`${backendUrl}/purchaseOrderInvoice`, {
        params,
      });

      // Filter out drafted orders here
      const filteredData = response.data.results.filter(
        (order) => order.invoiceState !== "drafted"
      );

      dispatch(slice.actions.getInvoicesSuccess(filteredData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


